/**
 * category: {
 *  viewable: is this file viewable in the browser
 *  editable: is this file editable in the browser
 *  unicode: unused, should be removed from structure
 *  kind: a high-level grouping of the category.
 *  css-clas: the icon image to use found in images folder
 *  extensions: for each extension of a given category, override the values
 * }
 *
 * This const needs some re-work and cleaning up.
 */

import { IFileTypes } from 'src/sync';

export const FILE_TYPE: IFileTypes = {
  archive: {
    viewable: false,
    editable: false,
    unicode: false,
    kind: 'archive',
    icon: 'file-type-archive',
    cssclass: 'mime-archive', // see global.css
    extensions: {
      '7z': {
        mimetype: 'application/x-7z-compressed',
      },
      zip: {
        mimetype: 'application/zip',
      },
      rar: {
        mimetype: 'application/x-rar-compressed',
      },
      gz: {
        mimetype: 'application/x-gzip',
      },
      gzip: {
        mimetype: 'application/x-gzip',
      },
      tar: {
        mimetype: 'application/x-tar',
      },
      bz2: {
        mimetype: 'application/x-bzip2',
      },
      tgz: {
        mimetype: 'application/x-gtar',
      },
      tbz2: {
        mimetype: 'application/x-gtar',
      },
      dmg: {
        mimetype: 'application/x-apple-diskimage',
      },
    },
  },
  audio: {
    viewable: false,
    editable: false,
    unicode: false,
    kind: 'audio',
    icon: 'file-type-audio',
    cssclass: 'mime-audio', // see global.css
    extensions: {
      wma: {
        mimetype: 'audio/x-ms-wma',
      },
      mp3: {
        mimetype: 'audio/mpeg',
        kind: 'mp3',
      },
      ogg: {
        mimetype: 'application/ogg',
      },
      wav: {
        mimetype: 'audio/x-wav',
      },
      m4a: {
        mimetype: 'audio/mp4a-latm',
      },
    },
  },
  binary: {
    viewable: false,
    editable: false,
    unicode: false,
    kind: 'binary',
    icon: 'file-type-bin',
    cssclass: 'mime-bin', // see global.css
    extensions: {
      exe: {
        mimetype: 'application/x-ms-dos-executable',
        icon: 'file-type-exe',
        cssclass: 'mime-exe',
      },
      bin: {
        mimetype: 'application/octet-stream',
      },
      bat: {
        mimetype: 'application/x-ms-dos-executable',
        icon: 'file-type-exe',
        cssclass: 'mime-exe',
      },
      iso: {
        mimetype: 'application/octet-stream',
        icon: 'file-type-cdimage',
        cssclass: 'mime-cdimage',
        kind: 'iso',
      },
    },
  },
  doc: {
    viewable: true,
    editable: false,
    unicode: false,
    kind: 'doc',
    icon: 'file-document',
    cssclass: 'mime-doc', // see global.css
    extensions: {
      doc: {
        icon: 'file-type-doc',
        mimetype: 'application/msword',
      },
      dot: {
        icon: 'file-type-dot',
        mimetype: 'application/msword',
      },
      docx: {
        icon: 'file-type-docx',
        mimetype: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        kind: 'docx',
      },
      docm: {
        icon: 'file-type-docm',
        mimetype: 'application/vnd.ms-word.document.macroEnabled.12',
      },
      dotm: {
        icon: 'file-type-dotm',
        mimetype: 'application/vnd.ms-word.template.macroEnabled.12',
      },
      dotx: {
        icon: 'file-type-dotx',
        mimetype: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
      },
      rtf: {
        mimetype: 'application/rtf',
      },
      odt: {
        icon: 'file-type-odt',
        mimetype: 'application/vnd.oasis.opendocument.text',
      },
      pdf: {
        mimetype: 'application/pdf',
        icon: 'file-type-pdf',
        cssclass: 'mime-pdf',
        kind: 'pdf',
      },
    },
  },
  image: {
    viewable: true,
    editable: false,
    unicode: false,
    kind: 'image',
    icon: 'file-type-image',
    cssclass: 'mime-image', // see global.css
    extensions: {
      jpg: {
        mimetype: 'image/jpeg',
      },
      jpeg: {
        mimetype: 'image/jpeg',
      },
      png: {
        mimetype: 'image/png',
      },
      gif: {
        mimetype: 'image/gif',
      },
      heic: {
        mimetype: 'image/heic',
        viewable: false,
      },
      heif: {
        mimetype: 'image/heif',
        viewable: false,
      },
      ai: {
        mimetype: 'application/illustrator',
        viewable: false,
        icon: 'file-type-illustrator',
        cssclass: 'mime-illustrator',
      },
      ico: {
        mimetype: 'image/vnd.microsoft.icon',
        viewable: false,
      },
      psd: {
        mimetype: 'image/x-photoshop',
        viewable: false,
      },
      bmp: {
        mimetype: 'image/x-ms-bmp',
        viewable: false,
      },
      svg: {
        mimetype: 'image/svg+xml',
        viewable: false,
      },
      tiff: {
        mimetype: 'image/tiff',
        viewable: false,
      },
      avif: {
        mimetype: 'image/avif',
        viewable: false,
      },
      webp: {
        mimetype: 'image/webp',
        viewable: false,
      },
    },
  },
  office: {
    viewable: false,
    editable: false,
    unicode: false,
    kind: 'doc',
    icon: 'file-document',
    cssclass: 'mime-doc', // see global.css
    extensions: {
      mdb: {
        mimetype: 'application/x-msaccess',
        cssclass: 'mime-mdb',
        icon: 'file-type-mdb',
      },
      ppt: {
        viewable: true,
        mimetype: 'application/vnd.ms-powerpoint',
        cssclass: 'mime-presentation',
        icon: 'file-type-ppt',
        kind: 'ppt',
      },
      pptx: {
        viewable: true,
        mimetype: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        cssclass: 'mime-presentation',
        icon: 'file-type-pptx',
        kind: 'pptx',
      },
      pptm: {
        icon: 'file-type-pptm',
        mimetype: 'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
      },
      ppsx: {
        icon: 'file-type-ppsx',
        mimetype: 'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
      },
      ppsm: {
        icon: 'file-type-ppsm',
        mimetype: 'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
      },
      pps: {
        icon: 'file-type-pps',
        mimetype: 'application/vnd.ms-powerpoint',
      },
      potx: {
        icon: 'file-type-potx',
        mimetype: 'application/vnd.openxmlformats-officedocument.presentationml.template',
      },
      potm: {
        icon: 'file-type-potm',
        mimetype: 'application/vnd.ms-powerpoint.template.macroenabled.12',
      },
      pot: {
        icon: 'file-type-pot',
        mimetype: 'application/vnd.ms-powerpoint',
      },
      odp: {
        icon: 'file-type-odp',
        mimetype: 'application/vnd.oasis.opendocument.presentation',
      },
    },
  },
  spreadsheet: {
    viewable: true,
    editable: false,
    unicode: false,
    kind: 'spreadsheet',
    icon: 'file-type-xlxs',
    cssclass: 'mime-spreadsheet', // see global.css
    extensions: {
      xls: {
        icon: 'file-type-xls',
        mimetype: 'application/vnd.ms-excel',
      },
      xlsx: {
        icon: 'file-type-xlsx',
        mimetype: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        cssclass: 'file-type-xlsx',
      },
      xlsm: {
        icon: 'file-type-xlsm',
        mimetype: 'application/vnd.ms-excel.sheet.macroEnabled.12',
      },
      xlsb: {
        icon: 'file-type-xlsb',
        mimetype: 'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
      },
      ods: {
        icon: 'file-type-ods',
        mimetype: 'application/vnd.oasis.opendocument.spreadsheet',
      },
    },
  },
  text: {
    viewable: true,
    editable: true,
    unicode: true,
    kind: 'text',
    icon: 'file-document',
    cssclass: 'mime-txt', // see global.css
    extensions: {
      txt: {
        mimetype: 'text/plain',
      },
      log: {
        mimetype: 'text/plain',
      },
      ini: {
        mimetype: 'text/plain',
      },
      csv: {
        icon: 'file-type-csv',
        mimetype: 'text/plain',
      },
      sh: {
        mimetype: 'text/plain',
        cssclass: 'mime-shell',
        icon: 'file-type-shell',
        kind: 'script',
      },
      php: {
        mimetype: 'text/plain',
        cssclass: 'mime-php',
        icon: 'file-type-php',
        kind: 'script',
      },
      py: {
        mimetype: 'text/plain',
        cssclass: 'mime-python',
        icon: 'file-type-python',
        kind: 'script',
      },
      pl: {
        mimetype: 'text/plain',
        cssclass: 'mime-perl',
        icon: 'file-type-perl',
        kind: 'script',
      },
      html: {
        mimetype: 'text/plain',
        icon: 'file-type-html',
        cssclass: 'mime-html',
      },
      js: {
        mimetype: 'text/plain',
        icon: 'file-type-javascript',
        cssclass: 'mime-javascript',
        kind: 'script',
      },
      json: {
        mimetype: 'text/plain',
      },
      css: {
        mimetype: 'text/plain',
        icon: 'file-type-css',
        cssclass: 'mime-css',
      },
      rb: {
        mimetype: 'text/plain',
        icon: 'file-type-ruby',
        cssclass: 'mime-ruby',
        kind: 'script',
      },
      xml: {
        mimetype: 'text/plain',
        icon: 'file-type-xml',
        cssclass: 'mime-xml',
        kind: 'script',
      },
      sql: {
        mimetype: 'text/plain',
        icon: 'file-type-sql',
        cssclass: 'mime-sql',
      },
      md: {
        mimetype: 'text/plain',
        icon: 'file-type-markdown',
        cssclass: 'mime-markdown',
      },
      markdown: {
        mimetype: 'text/plain',
        icon: 'file-type-markdown',
        cssclass: 'mime-markdown',
      },
    },
  },
  video: {
    viewable: false,
    editable: false,
    unicode: false,
    kind: 'video',
    icon: 'file-type-video',
    cssclass: 'mime-video', // see global.css
    extensions: {
      wmv: {
        mimetype: 'video/x-ms-wmv',
      },
      avi: {
        mimetype: 'video/avi',
      },
      flv: {
        mimetype: 'video/x-flv',
      },
      mpg: {
        mimetype: 'video/mpeg',
      },
      mpeg: {
        mimetype: 'video/mpeg',
      },
      mov: {
        mimetype: 'video/quicktime',
      },
      mkv: {
        mimetype: 'video/x-matroska ',
      },
      mp4: {
        mimetype: 'video/mp4',
      },
    },
  },
};
